var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"games"},_vm._l((_vm.games),function(element,key){return _c('div',{key:key},[_vm._v(" "+_vm._s(element.title)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }